<template>
  <v-row class="text-center">
    <v-col cols="12">
      <v-card elevation="3">
        <v-card-text>
          <div class="font-weight-medium">Session 1</div>

          <div class="text--primary">
            <div v-for="(r, k) in resource" :key="k" class="my-2">
              <a
                class="text-decoration-none font-weight-regular"
                :href="r.link"
              >
                {{ r.name }}</a
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    resource: [
      {
        name: "3030 STEM Program by CCL IIT Gn",
        link: "https://ccl.iitgn.ac.in/3030stem",
      },
      {
        name: "3030 Eklavya Program",
        link: "http://ccl.iitgn.ac.in/eklavya",
      },
      {
        name: "Story of surviving in Atlantic Ocean",
        link: "https://www.nytimes.com/2014/01/05/magazine/a-speck-in-the-sea.html",
      },
      {
        name: "Science of Junk Food",
        link: "https://www.nytimes.com/2013/02/24/magazine/the-extraordinary-science-of-junk-food.html",
      },
      {
        name: "Kati Kariko and COVID vaccine",
        link: "https://www.nytimes.com/2021/04/08/health/coronavirus-mrna-kariko.html",
      },
      {
        name: "Interesting Reads",
        link: "https://ccl.iitgn.ac.in/interesting-reads/",
      },
      {
        name: "CCL Youtube Channel",
        link: "https://www.youtube.com/c/IITGNCLI",
      },
    ],
  }),
};
</script>

<style>
</style>